import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  setOnline,
  setConnectionInfo,
} from "src/redux/slices/networkStatus";

/**
 * Suscribe al slice <c>networkStatus</c> los eventos del navegador:
 *   - <c>window.online/offline</c> → <c>setOnline</c>.
 *   - <c>navigator.connection.change</c> → <c>setConnectionInfo</c>
 *     (Network Information API — Chrome/Edge; Safari/iOS no lo soporta,
 *     en ese caso solo mostramos latencia).
 *
 * Se monta una sola vez (en DashboardLayout). La latencia la alimenta el
 * interceptor de axios en cada response real.
 */
export default function useNetworkStatus() {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleOnline = () => dispatch(setOnline(true));
    const handleOffline = () => dispatch(setOnline(false));
    const handleConnection = () => {
      const conn = typeof navigator !== "undefined" ? navigator.connection : null;
      if (!conn) return;
      dispatch(
        setConnectionInfo({
          effectiveType: conn.effectiveType,
          downlink: conn.downlink,
          rtt: conn.rtt,
        }),
      );
    };

    // Estado inicial
    dispatch(setOnline(typeof navigator !== "undefined" ? navigator.onLine : true));
    handleConnection();

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    const conn = typeof navigator !== "undefined" ? navigator.connection : null;
    if (conn?.addEventListener) conn.addEventListener("change", handleConnection);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      if (conn?.removeEventListener) conn.removeEventListener("change", handleConnection);
    };
  }, [dispatch]);
}
